import React from 'react';

export function UpgradeMessage({ showEasyFattMessage }) {
  return (
    <div style={{ width: '100%', 'text-align': 'center', padding: '30px' }}>
      <div>
        Questa funzionalità non è inclusa nel piano di abbonamento corrente.
      </div>

      {showEasyFattMessage ? (
        <div>
          Per togliere questa applicazione, vai su Tutte le impostazioni - Apps
          e cancella "Bilancio in Cloud" dall'elenco delle app a cui hai dato
          accesso.
        </div>
      ) : (
        <a
          href="https://app.reviso.com/#!/settings/subscription/pricing-page"
          style={{ color: '#1D8CD3' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          Sottoscrivi il piano di abbonamento successivo.
        </a>
      )}
    </div>
  );
}
